import {  GET_MAIL_READER,  UPDATE_MAILREADER_STATUS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getMailReader = (payload) => {
  return apiInstance.post(GET_MAIL_READER, payload);
};
export const updateMailReaderStatus = (payload) => {
  return apiInstance.post(UPDATE_MAILREADER_STATUS, payload);
};
